import React, { useEffect, useState } from "react";
import { MessageCircle, RefreshCw } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

const TONE = {
  pushed_to_zoho: "bg-emerald-100 text-emerald-700",
  invoiced_in_zoho: "bg-sky-100 text-sky-700",
  zoho_push_failed: "bg-rose-100 text-rose-700",
  queued: "bg-slate-100 text-slate-600",
};
const EVENT = { buyer_approved: "Account approved", order_received: "Order received", order_invoiced: "Packed / invoiced" };

export default function WhatsAppLog() {
  const [data, setData] = useState(null);
  const load = () => api.get("/admin/notifications").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!data) return null;
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-5 mt-6" data-testid="whatsapp-log">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-heading font-semibold text-slate-900 flex items-center gap-2"><MessageCircle className="h-4 w-4" /> Zoho pushes (WhatsApp workflows)</h3>
        <Button size="sm" variant="outline" className="rounded-full" onClick={load} data-testid="whatsapp-log-refresh"><RefreshCw className="h-3.5 w-3.5" /></Button>
      </div>
      <p className="text-xs text-slate-500 bg-slate-50 rounded-lg px-3 py-2 mb-3" data-testid="whatsapp-zoho-note">
        The portal pushes approved customers and sales orders to Zoho. Your Zoho WhatsApp workflows send the messages. This log shows each push.
      </p>
      {data.notifications.length === 0 && <p className="text-sm text-slate-400">No alerts yet.</p>}
      <div className="divide-y divide-slate-100">
        {data.notifications.map((n) => (
          <div key={n.id} className="py-2.5 flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4" data-testid={`whatsapp-row-${n.id}`}>
            <div className="sm:w-40 shrink-0">
              <div className="text-sm font-medium text-slate-900">{EVENT[n.event] || n.event}</div>
              <div className="text-[11px] text-slate-400">{new Date(n.created_at).toLocaleString()}</div>
            </div>
            <div className="flex-1 min-w-0 text-xs text-slate-600">
              <div className="font-mono-num text-slate-500">{n.to || "no number"} · via Zoho{n.zoho_contact_id ? ` · contact ${n.zoho_contact_id}` : ""}{n.salesorder_id ? ` · SO ${n.salesorder_id}` : ""}</div>
              <div className="mt-0.5 line-clamp-2">{n.text}</div>
              {n.error && <div className="text-rose-600 mt-0.5">{n.error}</div>}
            </div>
            <Badge className={`border-0 shrink-0 ${TONE[n.status] || TONE.queued}`}>{(n.status || "").replaceAll("_", " ")}</Badge>
          </div>
        ))}
      </div>
    </div>
  );
}
